module.exports = __webpack_public_path__ + "media/images/icons/collapse-down-c3e91fa0f9c47ec510eb3fdf3de936d4.svg";